/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CardSuit {
    HEART = 'heart',
    CLOVER = 'clover',
    CLUB = 'club',
    DIAMOND = 'diamond',
}
